import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="常见问题"
              title="关于网红事件，你可能想先弄清楚这些"
              desc="整理了读者问得最多的几个问题，涉及信息核查方式、更新节奏与我们的立场。"
            />
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              查看全部问题
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="lg:col-span-8">
            <FaqAccordion items={faqs.slice(0, 6)} />
          </div>
        </div>
      </div>
    </section>
  );
}